import { Directive, Pipe } from '@angular/core';

@Pipe({
  name: 'subEventPriority',
  standalone: false
})

export class SubEventPriorityPipe {
  transform(element, eventId, type) {
    if (type === 'priority') {
      // if (element[eventId + '_manual']) {
      //   return element[eventId + '_manual'];
      // }
      // if (element[eventId + '_auto']) {
      //   return element[eventId + '_auto'];
      // }
      return element[eventId] ? element[eventId] : '';
    }
    if (type === 'color') {
      if (element[eventId + '_manual']) {
        return 'blue';
      }
      if (element[eventId + '_auto']) {
        return 'green';
      }
      return 'black';
    }
    if (type === 'background') {
      return element.filter(el => el.hasOwnProperty(eventId)).length;
    }
  }
}
